module.exports = __webpack_public_path__ + "img/icon-gen-payulog.976ddd0f.png";